function checkExerciseAnswers(diagram_id, submit_btn, next_btn) {
  var elements = document.querySelectorAll('#' + diagram_id + ' input');
  var correct_elements = document.querySelectorAll('#' + diagram_id + ' input[data-correct]');

  for (var i = 0; i < elements.length; i++) {
    removeOldClass(elements[i]);
    if (elements[i].hasAttribute('data-correct') && elements[i].checked) {
      elements[i].classList.add('correct');
    } else if ((elements[i].hasAttribute('data-correct') && !elements[i].checked) ||
               (!elements[i].hasAttribute('data-correct') && elements[i].checked)){
                 elements[i].classList.add('wrong');
               };
  };

  var correct_answers_counter = document.querySelectorAll('#' + diagram_id + ' .correct').length;
  var incorrect_answers_counter = document.querySelectorAll('#' + diagram_id + ' .wrong').length;
  var next_button = document.getElementById(next_btn);

  if (correct_answers_counter == correct_elements.length && incorrect_answers_counter == 0) {
    disabledCheckboxes(elements);
    submit_btn.style = 'display: none;';
    next_button.style = 'display: inline-block; opacity: 1;';
  };
}

function removeOldClass(el) {
  el.classList.remove('correct', 'wrong');
}

function disabledCheckboxes(arr) {
  for (var i = 0; i < arr.length; i++) {
    arr[i].disabled = true;
  };
}

function submit(diagram_id, submit_btn, next_btn) {
  var action_button = document.getElementById(submit_btn);

  action_button.addEventListener('click', function (el) {
    checkExerciseAnswers(diagram_id, el.srcElement, next_btn);
  });
}

export default function submitAction(diagram_id, submit_btn, next_btn) {
  submit(diagram_id, submit_btn, next_btn);
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/1/1c/diagram_logic.js